export var audioVisitation = function audioVisitation(siteApi) {
  return {
    index: function index(params) {
      return siteApi.get('/audio-visitation', {
        params: params
      });
    },
    get: function get(id) {
      return siteApi.get("/audio-visitation/".concat(id));
    },
    booth: {
      index: function index(params) {
        return siteApi.get('/audio-visitation/booth', {
          params: params
        });
      }
    }
  };
};